import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService } from '../auth/auth.service';
import * as firebase from 'firebase/app';
import 'firebase/storage'
import { AngularFireAuth } from 'angularfire2/auth';

@Injectable({
    providedIn: 'root'
})
export class RealtimeApiService {

    sender_id: any;

    constructor(
        private afAuth: AngularFireAuth,
        private afdb: AngularFireDatabase,
        private auth: AuthService
    ) {
        if (this.auth.countryCode == 'GT') {
            this.sender_id = 'BarllenoGT';
        } else
            if (this.auth.countryCode == 'HN') {
                this.sender_id = 'BarllenoHN';
            } else
                if (this.auth.countryCode == 'DO') {
                    this.sender_id = 'BarllenoDO';
                } else
                    if (this.auth.countryCode == 'CO') {
                        this.sender_id = 'BarllenoCO';
                    } else
                        if (this.auth.countryCode == 'SV') {
                            this.sender_id = 'Barlleno';
                        }
    }

    getConversationId(user_key) {

        return this.afdb.object(`/accounts/${this.sender_id}/conversations/` + user_key);
    }

    // Get messages of the conversation given the Id.
    getConversationMessages(conversationId) {
        return this.afdb.object('/conversations/' + conversationId + '/messages');
    }

    // Get conversation given the conversationId.
    getConversation(conversationId) {
        return this.afdb.object('/conversations/' + conversationId);
    }

    // Get conversation given the conversationId.
    getUsersConversation(conversationId) {
        return new Promise((resolve, reject) => {
            firebase.database().ref()
                .child(`/conversations/${conversationId}`)
                .once("value", (data) => {
                    resolve(data.val().users);
                })
        })
    }

    getConversations() {
        return this.afdb.list(`/accounts/${this.sender_id}/conversations`)
    }

    // Get user by their userId
    getUser(userId) {
        return this.afdb.object('/accounts/' + userId);
    }

    addMessage(conversationId, message) {

        this.getConversationMessages(conversationId).query.once('value', snapshot => {

            let chat_key = firebase.database().ref().child(`/conversations/${conversationId}/messages`).push().key;

            let updates = {};

            updates[`/conversations/${conversationId}/messages/${snapshot.numChildren()}`] = message;

            firebase.database().ref().update(updates);
        })


    }




}
